export enum MessageJobSeverity {
    Info = 0,
    Warning = 100,
    PartialSuccess = 150,
    Important = 175,
    Error = 200,
    Success = 1000,
    Failed = 1500,
    CopyConfigSuccess = 2000,
    CopyConfigExportOnlySuccess = 2001,
    CloneSuccess = 2010,
    CloneExportOnlySuccess = 2011,
}
